module.exports = __webpack_public_path__ + "static/media/loading.8a5e2638.svg";